'use client';

import React from 'react';
import Link from 'next/link';

import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { LEGAL_DOCUMENTS, RECURRING_CONSENT_TEXT } from '@/lib/legal-documents';

interface RecurringConsentBlockProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  amountLabel: string;
  frequencyLabel: string;
  className?: string;
  checkboxId?: string;
}

export function RecurringConsentBlock({
  checked,
  onCheckedChange,
  amountLabel,
  frequencyLabel,
  className,
  checkboxId = 'recurring-consent',
}: RecurringConsentBlockProps) {
  return (
    <div
      className={cn(
        'space-y-3 rounded-lg border border-[color:var(--site-border-soft)] bg-[color:rgba(255,255,255,0.7)] p-4',
        className,
      )}
    >
      <div className="space-y-1">
        <p className="text-xs font-semibold uppercase tracking-wide text-[var(--site-ink-muted)]">
          Автосписания
        </p>
        <p className="text-sm text-[var(--site-ink)]">
          После первого успешного платежа мы будем списывать{' '}
          <span className="font-semibold text-[var(--site-ink-strong)]">{amountLabel}</span>{' '}
          <span className="whitespace-nowrap">{frequencyLabel}</span> до отмены подписки в разделе оплаты.
        </p>
      </div>

      <div className="flex items-start gap-3">
        <input
          id={checkboxId}
          type="checkbox"
          checked={checked}
          onChange={(event) => onCheckedChange(event.target.checked)}
          className="mt-0.5 h-4 w-4 rounded border border-[color:var(--site-border-mid)] text-[var(--site-primary-fill)] focus:ring-2 focus:ring-[var(--site-primary-fill)]"
        />
        <div className="space-y-2">
          <Label htmlFor={checkboxId} className="text-sm font-medium leading-6 text-[var(--site-ink)]">
            {RECURRING_CONSENT_TEXT}
          </Label>
          <p className="text-xs leading-5 text-[var(--site-ink-muted)]">
            Условия подписки опубликованы в{' '}
            <Link
              href={LEGAL_DOCUMENTS.offer.path}
              target="_blank"
              rel="noreferrer"
              className="font-medium text-[var(--site-accent-text)] hover:underline"
            >
              публичной оферте
            </Link>
            . Согласие не проставлено по умолчанию и сохраняется в истории аккаунта.
          </p>
        </div>
      </div>
    </div>
  );
}
